import qs from 'qs';
import { trackPromise } from 'react-promise-tracker';
import api from '../../../utils/API';

const URL = process.env.REACT_APP_IPA_PRICE_TABLES_MANAGER_URL;

export const getPlataformaPrecificacaoFilters = (name, data) =>
  trackPromise(
    api({
      url: `${URL}/produto/filtros/${name}`,
      method: 'GET',
      expectToken: true,
      params: {
        page: data.page,
        size: data.size,
        query: data.query,
      },
    }).then(res => res),
    'precificacao-filters',
  );
